import { MatDialog } from "@angular/material/dialog";
import { NeedsAttentionInput } from "./needs-attention.model";
import { ProductCodeLabel } from "../product/product.model";
import { SimpleDialogComponent } from "../ui/dialog/simple-dialog/simple-dialog.component";

export class NeedsAttentionHelper {
  static openNeedsAttentionDialog(dialog: MatDialog, input: NeedsAttentionInput, productCode: string = null): void {
    const body = this.getNeedsAttentionMessageWithProductCode(input, productCode, true);

    SimpleDialogComponent.show(dialog, { title: 'Attention needed', body })
  }

  static getNeedsAttentionMessageWithProductCode(input: NeedsAttentionInput, productCode: string = undefined, isHtml: boolean = false): string {
    if (!input) {
      return undefined;
    }
    return this.getNeedsAttentionMessage(
      {
        ...input,
        productName: productCode ? ProductCodeLabel.get(productCode) : input.productName
      },
      isHtml);
  }

  static getNeedsAttentionMessage(input: NeedsAttentionInput, isHtml: boolean = false): string {
    const emailMsg = isHtml ? `<a href="mailto:${input?.email}">${input?.email}</a>` : input?.email;
    return `In order to access your ${input?.productName?.toLowerCase()}, please contact your Business Advisor ${input?.firstName} ${input?.lastName} at ${emailMsg} or ${input?.phone}`
  }
}
